<script>
import { services } from '@utils/common-services'
import { appConfig } from '@src/app.config'

export default {
  page: {
    title: 'Login',
    meta: [{ name: 'description', content: `Login to ${appConfig.title}` }],
  },

  data() {
    return {
      authorizationFailed: false,
    }
  },
  mounted() {},
  beforeMount() {
    // console.log(this.$route.params.value)
    this.getAuthorization()
  },
  beforeDestroy() {
    var doc = this.$refs.sessionOut
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    getAuthorization() {
      if (services.authorized()) {
        this.authorizationFailed = true
        var parent = this
        setTimeout(() => {
          services.removeAuth()
          parent.$router.push({ name: 'login' })
        }, 2000)
      }
    },
  },
}
</script>

<template>
  <div ref="sessionOut">
    <div v-if="authorizationFailed">
      <CommonBaseVerificationSession :session="authorizationFailed"
    /></div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
